export default function HeaderClientContent({ isHomepage, superHeroContent }) {
    const className = `enhanced-super-hero-client-header${isHomepage ? '-hp' : '-slp'}`;

    return (
        <div className={className}>
            <span dangerouslySetInnerHTML={{ __html: superHeroContent.bodyText?.header }} />
        </div>
    );
}
